import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

export const ExcelDowloadServices = {
  async getProductExcell() {
    const token = getCookie("BscAdminToken");

    let response = await $axios
      .get($api("product_excell"), {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getServicesExcell() {
    const token = getCookie("BscAdminToken");
    console.log(token)
    let response = await $axios
      .get($api("services_excell"), {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getAccesoryExcell() {
    const token = getCookie("BscAdminToken");

    let response = await $axios
      .get($api("accessory_excell"), {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  // Yeni API endpoint-ləri üçün funksiyalar
  async getProductOrdersExcell() {
    const token = getCookie("BscAdminToken");

    let response = await $axios
      .get($api("product_orders_export"), {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getServiceOrdersExcell() {
    const token = getCookie("BscAdminToken");

    let response = await $axios
      .get($api("service_orders_export"), {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getAccessoryOrdersExcell() {
    const token = getCookie("BscAdminToken");

    let response = await $axios
      .get($api("accessory_orders_export"), {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
